import React from 'react';
import { useApplicationSyncContext } from '../../ApplicationSyncContext/useApplicationSyncContext';
import useAudioWebsocketApiConnectionContext from '../WebsocketConnectionProviders/AudioWebsocketApiConnectionContext/useAudioWebsocketApiConnectionContext';
import useWebsocketApiConnectionContext from '../WebsocketConnectionProviders/WebsocketApiConnectionContext/useWebsocketApiConnectionContext';
import { AudioServerCommunicationContext } from './useAudioServerCommunicationContext';

export default function AudioServerCommunicationContextProvider({ children }: { children: React.ReactNode }) {
  const { isSynced } = useApplicationSyncContext();
  const { sendJsonMessage: sendAudioWebsocketJsonMessage } = useAudioWebsocketApiConnectionContext();
  const { sendJsonMessage: sendWebsocketApiJsonMessage } = useWebsocketApiConnectionContext();

  const value = React.useMemo(
    () => ({
      sendJsonMessage: isSynced ? (jsonMessage, keep) => sendWebsocketApiJsonMessage({ type: 'ForwardAppEvent', message: null, payload: jsonMessage }, keep)
        : (jsonMessage, keep) => sendAudioWebsocketJsonMessage(jsonMessage, keep)
      ,
    }),
    [isSynced, sendAudioWebsocketJsonMessage, sendWebsocketApiJsonMessage],
  );

  return (
    <AudioServerCommunicationContext.Provider value={value}>
      {children}
    </AudioServerCommunicationContext.Provider>
  );
}
